const $ = require('jquery');

module.exports = function (shopperService, shopPageStateService, moveFocus, $timeout) {
    return {
        restrict: 'E',
        template: require('./global-header-skip-links-template.html').trim(),
        scope: {},
        link(scope) {
            scope.shopper = shopperService;
            scope.a11yOptionsOpen = false;
            scope.keyboadNavigation = false;

            scope.openA11yOptions = function () {
                scope.a11yOptionsOpen = true;
            };

            scope.updatePreference = function () {
                shopperService.setPreferenceEnableAccessibility(shopperService.preferences.EnableAccessibleOptions);
            };

            scope.goToTrolley = function () {
                if (shopPageStateService.panels.right) {
                    moveFocus('#right-panel');
                } else {
                    shopPageStateService.triggerPanel('right', true, 'header');
                }
            };

            scope.enableKeyboardNavigation = function () {
                if (!scope.keyboadNavigation) {
                    $('body').addClass('keyboard-user');
                    scope.keyboadNavigation = true;
                }
            };

            // auto hide focus is outside of the panel
            $('._a11yOptions').off('focusout.a11yOptions').on('focusout.a11yOptions', function () {
                // Timeout here because no item has focus yet, the check will now happen after focusin event has fired.
                $timeout(function () {
                    // toggle if focus goes outside of small menu container
                    if ($(document.activeElement).closest('._a11yOptions').length === 0) {
                        scope.a11yOptionsOpen = false;
                    }
                }, 0);
            });
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/globalheader/global-header-skip-links-directive.js
 **/